import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { INgsiEntityIdAttrs } from '../../shared/interfaces/ngsi/entity.interface';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class CompassService {
  private readonly selectedEntityId: Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>> =
      new Map<string, BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined >>();

  // Gets the observable for a specific widgetId
  getCompassEntity$(widgetId: string): Observable<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined> {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    return this.selectedEntityId.get(widgetId)!.asObservable();
  }

  // Sets a new compass entity for a specific widgetId
  setCompassEntity(widgetId: string, entityId: Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined): void {
    if (!this.selectedEntityId.has(widgetId)) {
      this.selectedEntityId.set(widgetId, new BehaviorSubject<Omit<INgsiEntityIdAttrs, 'ngsildPrefix'> | undefined>(undefined));
    }

    this.selectedEntityId.get(widgetId)!.next(entityId);
  }

  // Clean up
  removeCompassEntity(widgetId: string): void {
    const subject = this.selectedEntityId.get(widgetId);
    if (subject) {
      subject.complete(); // Clean up subscribers
      this.selectedEntityId.delete(widgetId);
    }
  }
}
